import { componentProvider } from 'js-component-framework/es';
import { Tablist } from 'aria-components';

// Import styles.
import './tab-list.scss';

/**
 * TabList component.
 */
class TabList {
  /**
   * Start the component
   */
  constructor({ children, element, options }) {
    this.children = children;
    this.element = element;
    this.options = options;

    // Bind class methods.
    this.init = this.init.bind(this);
    this.refreshInnerCarousel = this.refreshInnerCarousel.bind(this);

    this.init();
  }

  /**
   * Initialize a TabList instance.
   */
  init() {
    const { tabs, panels } = this.children;
    this.tablist = new Tablist({ tabs, panels });

    // Check if any of the tab panels contains a carousel.
    const hasCarousel = this.tablist.panels
      .some((panel) => panel.querySelector('ai-carousel') !== null);

    // Track state changes if any of the panels contains a carousel.
    if (hasCarousel) {
      this.tablist.onStateChange = this.refreshInnerCarousel;
    }
  }

  /**
   * If there is a carousel within the active tab, add the `refresh` attribute,
   * which will prompt the carousel to run its resize handler. Together, these
   * actions will ensure the active tab's carousel functions as expected.
   *
   * @param {number} state.activeIndex The active tab's index.
   */
  refreshInnerCarousel({ activeIndex }) {
    this.tablist.panels.forEach((panel, index) => {
      const aiCarousel = panel.querySelector('ai-carousel');

      if (aiCarousel !== null) {
        aiCarousel.setAttribute('refresh', (activeIndex === index));
      }
    });
  }
}

const tabListConfig = {
  name: 'tab-list',
  component: TabList,
  querySelector: {
    tabs: '.tabs__list',
  },
  querySelectorAll: {
    panels: '.tabs__panel',
  },
};

componentProvider(tabListConfig);
